/* eslint-disable react/prop-types */
import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useSnackbar } from "notistack";
import athenaClient from "lib/axios/clients";
import { REACT_APP_BASE_URL } from "resources/constants";
import { downloadBlob } from "lib/utils";
import { makeStyles } from "@material-ui/core";
import moment from "moment";
import mixpanelTrack from "app/common/MixpanelComponent";

const useStyles = makeStyles(() => ({
  circularProgress: {
    color: "white",
  },
}));

const withExportElasticities = (
  WrappedComponent,
  excelGroupByParam,
  excelGroupByTwoParam,
  dateChecked,
  dateMin,
  dateMax
) => {
  return (props) => {
    const classes = useStyles();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const FILETYPE = "xlsx";
    let queryGroupBy = "";
    const excelGroupBy =
      excelGroupByParam.key !== null
        ? excelGroupByParam.key
        : excelGroupByTwoParam.key;

    if (dateChecked) {
      queryGroupBy =
        excelGroupByTwoParam.key !== null && excelGroupByParam.key !== null
          ? `date,${excelGroupByParam.key},${excelGroupByTwoParam.key}`
          : `date,${excelGroupBy}`;
    } else {
      queryGroupBy =
        excelGroupByTwoParam.key !== null && excelGroupByParam.key !== null
          ? `${excelGroupByParam.key},${excelGroupByTwoParam.key}`
          : excelGroupBy;
    }
    const fileName = `elasticities_by_${queryGroupBy.replaceAll(
      ",",
      "_"
    )}_from_${moment(dateMin).format("MMM'YY")}_to_${moment(dateMax).format(
      "MMM'YY"
    )}`;

    const loadingCircle = () => (
      <CircularProgress size={24} className={classes.circularProgress} />
    );

    const exportElasticities = () => {
      const config = {
        method: "GET",
        url: `${REACT_APP_BASE_URL}/elasticities`,
        params: {
          file: FILETYPE,
          group_by: queryGroupBy,
          min_date: dateMin,
          max_date: dateMax,
        },
        responseType: "blob",
      };

      return athenaClient.request(config);
    };

    const handleClick = (e) => {
      /* MIXPANEL TRACKS */
      mixpanelTrack(`Export elasticities`);
      /* END OF MIXPANEL TRACKS */

      e.stopPropagation();
      if (props.afterClick) props.afterClick(e);

      const snackbarKey = enqueueSnackbar(
        `${fileName} is getting ready for download`,
        {
          persist: true,
          action: loadingCircle,
        }
      );

      exportElasticities()
        .then((response) => {
          enqueueSnackbar(`Download for ${fileName} is ready!`, {
            variant: "success",
          });

          downloadBlob(response.data, fileName, FILETYPE);
        })
        .catch(() => {
          enqueueSnackbar(
            `Error when downloading ${fileName}. Try again shortly`,
            {
              variant: "error",
            }
          );
        })
        .finally(() => {
          closeSnackbar(snackbarKey);
        });
    };

    return (
      <WrappedComponent
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
        onClick={handleClick}
        onMouseDown={handleClick}
      />
    );
  };
};

export default withExportElasticities;
